export default "__VITE_ASSET__095bba65__"